import firebase from 'firebase'

var firebaseConfig = {
    apiKey: "AIzaSyA0A73ET2mzUIPjstvLqcyYOXqjpZ3Y2sM",
    authDomain: "codezap-e156b.firebaseapp.com",
    databaseURL: "https://codezap-e156b.firebaseio.com",
    projectId: "codezap-e156b",
    storageBucket: "codezap-e156b.appspot.com",
    messagingSenderId: "257828838664",
    appId: "1:257828838664:web:30d71d14f245d7c5b3e0bd",
    measurementId: "G-BG75BBCN85"
};

const fire = firebase.initializeApp(firebaseConfig);

export default fire